import {
  UPDATE_PAGE_TEMPLATE_NAME,
  UPDATE_PAGE_TEMPLATE_USER_LABEL,
  ADD_AVAILABLE_PAGES,
  REMOVE_AVAILABLE_PAGE
} from '../actions';

export default function (state = {}, action) {
  switch (action.type) {
  case UPDATE_PAGE_TEMPLATE_NAME: {
    const { id, name, templateType } = action.payload;
    const templates = [...state].map(template => ({
      ...template,
      name: template.id == id && template.template_type === templateType
        ? name
        : template.name
    }));

    return templates;
  }
  case UPDATE_PAGE_TEMPLATE_USER_LABEL: {
    const { id, userLabel, templateType } = action.payload;
    const templates = [...state].map(template => ({
      ...template,
      user_label: template.id == id && template.template_type === templateType
        ? userLabel
        : template.user_label
    }));

    return templates;
  }
  case ADD_AVAILABLE_PAGES: {
    return [...state, ...action.payload];
  }
  case REMOVE_AVAILABLE_PAGE: {
    const { id, templateType } = action.payload;
    return state.filter(page => !(page.id === id && page.template_type === templateType));
  }
  default:
    return state;
  }
}
